import { isCompletedToolStatus } from './tool-key.js';

export type ParsedBridgeSessionUpdate = {
  updateKind: string;
  toolName: string;
  isToolUpdate: boolean;
  isCompletedToolCallUpdate: boolean;
};

export function parseBridgeSessionUpdate(params: unknown): ParsedBridgeSessionUpdate {
  const p = params as {
    sessionUpdate?: string;
    session_update?: string;
    type?: string;
    toolCall?: { name?: string; arguments?: string };
    tool_call?: { name?: string; arguments?: string };
    status?: unknown;
  };
  const updateKind = p.sessionUpdate ?? p.session_update ?? p.type ?? 'update';
  const isCompletedToolCallUpdate =
    updateKind === 'tool_call_update' && isCompletedToolStatus(p.status);
  const toolName = p.toolCall?.name ?? p.tool_call?.name ?? '';
  const isToolUpdate =
    updateKind === 'tool_call' ||
    updateKind === 'tool_call_update' ||
    (typeof toolName === 'string' && toolName.length > 0);

  return { updateKind, toolName, isToolUpdate, isCompletedToolCallUpdate };
}
